import React from "react";
import { Routes, Route } from "react-router-dom";

import routes from "./constants/routes";
import OrderModificationSummary from "./containers/OrderModificationSummary/OrderModificationSummary";
import ModifiedOrderSummary from "./containers/ModifiedOrderSummary/ModifiedOrderSummary";
import RejectedOrderModification from "./containers/RejectedOrderModification/RejectedOrderModification";
const AppRoutes = () => {
    return (
        <Routes>
            <Route
              path='/'
              element={<OrderModificationSummary />}
            />
            <Route path={routes.modifiedOrderSummary} element={<ModifiedOrderSummary />} />
            <Route path={routes.rejectedOrderModification} element={<RejectedOrderModification />} />
        </Routes>
    );
};

export default AppRoutes;